const initBlockVacancies = () => {
    const body = document.querySelector('body');
    body.addEventListener('click', (event) => {
        var _a, _b, _c;
        const clickElem = event === null || event === void 0 ? void 0 : event.target;
        const ROLE = (_a = clickElem.dataset) === null || _a === void 0 ? void 0 : _a.role;
        if (!ROLE)
            return;
        switch (ROLE) {
            case 'partners-filter':
                {
                    event.preventDefault();
                    const termId = (_b = clickElem.dataset.id) !== null && _b !== void 0 ? _b : '';
                    const termType = (_c = clickElem.dataset.type) !== null && _c !== void 0 ? _c : '';
                    if (!termId || !termType)
                        return;
                    const url = new URL(window.location.href);
                    const params = new URLSearchParams(url.search);
                    const termParam = params.get(termType);
                    url.searchParams.delete('paged');
                    if (termParam) {
                        const termParamArr = termParam.split(',');
                        if (termParamArr.indexOf(termId) !== -1) {
                            const termParamNew = termParamArr.filter((term) => term !== termId);
                            if (termParamNew.length) {
                                url.searchParams.set(termType, termParamNew.join(','));
                            }
                            else {
                                url.searchParams.delete(termType);
                            }
                        }
                        else {
                            termParamArr.push(termId);
                            url.searchParams.set(termType, termParamArr.join(','));
                        }
                    }
                    else {
                        url.searchParams.set(termType, termId);
                    }
                    window.location.href = url.href;
                }
                break;
            case 'reset-partners-filter':
                {
                    event.preventDefault();
                    const url = new URL(window.location.href);
                    url.searchParams.delete('paged');
                    url.searchParams.delete('payment_vertical');
                    url.searchParams.delete('traffic_sources');
                    url.searchParams.delete('number_offers');
                    url.searchParams.delete('payment_models');
                    window.location.href = url.href;
                }
                break;
        }
    });
};
window.document.addEventListener('DOMContentLoaded', initBlockVacancies, false);
export {};
